import { LoraNetworkProfile } from "./loraNetworkProfile.js";
import { LORA_MODE, ResponsivenessSettings } from "./subSchemas/responsivenessSettings.js";
import { Device } from "../device/device.js";
import { LoraNetworkProfileSupportedDeviceSelector } from "./subSchemas/loraNetworkProfileSupportedDeviceSelector.js";

export function doesDeviceSupportProfile(self: LoraNetworkProfile, device: Device): boolean {
    return LoraNetworkProfileSupportedDeviceSelector.utilities.doesDeviceSupportSelector(
        self.supportedDeviceSelector,
        device,
    );
}

export function shouldQueueDownlinksAsynchronously(self: LoraNetworkProfile, isActive: boolean) {
    const responsivenessSettings = getResponsivenessSettings(self, isActive);

    if (responsivenessSettings.loraMode === LORA_MODE.CLASS_B) {
        return true;
    }
    if (self.queueClassADownlinksInAdvance) {
        return true;
    }
    return false;
}

export function getResponsivenessSettings(self: LoraNetworkProfile, isActive: boolean) {
    if (isActive) {
        return self.responsivenessSettings;
    } else {
        return self.inactiveResponsivenessSettings;
    }
}

/**
 * Returns worst-case response time in ms
 * @param self
 * @param isActive
 */
export function getWorstCaseResponseTime(self: LoraNetworkProfile, isActive: boolean): number {
    return ResponsivenessSettings.getters.getWorstCaseResponseTime(getResponsivenessSettings(self, isActive));
}

/**
 * Returns worst-case response time in ms
 * @param self
 * @param isActive
 */
export function getBestCaseResponseTime(self: LoraNetworkProfile, isActive: boolean): number {
    return ResponsivenessSettings.getters.getBestCaseResponseTime(getResponsivenessSettings(self, isActive));
}
